import React from 'react';

const SoundDecision = ({ setSoundDecisionMade, setSoundOn, setAmbientMusic, setVolume }) => {

    const handleSound = (choice) => {
        if (choice === true) {
            setSoundOn(true)
            setAmbientMusic(true)
            setVolume(10)
        } else {
            setSoundOn(false)
            setAmbientMusic(false)
            setVolume(0)
        }
        setSoundDecisionMade(true)
    }

    return (
        <div
            className="flex flex-col justify-center items-center h-screen text-white bg-gray-800 bg-opacity-50 xs:text-lg md:text-3xl"
        >
            <p className="font-bold mb-4">Do you want to turn on the volume?</p>
            <div className="flex gap-16">
                <button
                    className="px-10 py-2 bg-gray-500 hover:bg-gray-600 rounded text-white font-semibold"
                    onClick={() => handleSound(true)}
                >
                    Yes
                </button>
                <button
                    className="px-10 py-2 bg-gray-500 hover:bg-gray-600 rounded text-white font-semibold"
                    onClick={() => handleSound(false)}
                >
                    No
                </button>
            </div>
        </div>
    );
};

export default SoundDecision;